
import { defineComponent, ref, reactive, toRefs, onMounted, watch, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Charts, Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      option: {},
      columns: [],
      columns2: [],
      data: [],
      data1: [],
      info: {},
      spinning: true
    })
    const color = globalsets.getColor()

    pageData.columns = [
      {
        title: '年度',
        dataIndex: 'Year',
        key: 'Year',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '预测机构数',
        dataIndex: 'AgentNum',
        key: 'AgentNum',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '最小值 (元)',
        dataIndex: 'EPSMin',
        key: 'EPSMin',
        width: '100px',
        slots: { customRender: 'decimal' }
      },
      {
        title: '最大值 (元)',
        dataIndex: 'EPSMax',
        key: 'EPSMax',
        width: '100px',
        slots: { customRender: 'decimal' }
      },
      {
        title: '均值 (元)',
        dataIndex: 'EPSAvg',
        key: 'EPSAvg',
        width: '100px',
        slots: { customRender: 'decimal' }
      }
    ]
    pageData.columns2 = [
      {
        title: '年度',
        dataIndex: 'Year',
        key: 'Year',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '预测机构数',
        dataIndex: 'AgentNumForProfit',
        key: 'AgentNumForProfit',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '最小值 (元)',
        dataIndex: 'PNetProfitMin',
        key: 'PNetProfitMin',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '最大值 (元)',
        dataIndex: 'PNetProfitMax',
        key: 'PNetProfitMax',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '均值 (元)',
        dataIndex: 'PNetProfitAvg',
        key: 'PNetProfitAvg',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      }
    ]
    function compare(max: number, min: number) {
      let a, b, interval: any
      if (max <= 0) {
        a = 0
        b = 3
        interval = Number((Math.abs(min) / 3).toFixed(6))
      } else if (min >= 0) {
        a = 3
        b = 0
        interval = Number((Math.abs(max) / 3).toFixed(6))
      } else {
        if (max + min > 0) {
          // 正 3格
          interval = Number((Math.abs(max) / 3).toFixed(6))
          a = 3
          b = Number((Math.abs(min) / interval).toFixed(6)) // 格子数
        } else {
          // 负 3格
          interval = Number((Math.abs(min) / 3).toFixed(6))
          a = Number((Math.abs(max) / interval).toFixed(6))
          b = 3
        }
      }
      return [a, b, interval]
    }
    function setoption() {
      const data = JSON.parse(JSON.stringify(pageData.data1)) || []
      data.forEach((item: any) => {
        if (item.Tag === 1) {
          item.Year = item.Year + '（预测）'
        }
      })
      const xAxis = data.map((item: any) => item.Year)
      const arr1 = data.map((item: any) => item.PNetProfit)
      const arr2 = data.map((item: any) => item.EPS)
      const max1 = Math.max(...arr1)
      const min1 = Math.min(...arr1)
      const max2 = Math.max(...arr2)
      const min2 = Math.min(...arr2)
      let maxLeft, minLeft, maxRight, minRight, inte1, inte2

      if (max1 <= 0 && max2 <= 0) {
        // 全部为负数
        inte1 = Math.abs(Number((min1 / 5).toFixed(6)))
        inte2 = Math.abs(Number((min2 / 5).toFixed(6)))
        maxLeft = 0
        minLeft = min1
        maxRight = 0
        minRight = min2
      } else if (min1 >= 0 && min2 >= 0) {
        // 全部为正数
        inte1 = Number((max1 / 5).toFixed(6))
        inte2 = Number((max2 / 5).toFixed(6))
        maxLeft = max1
        minLeft = 0
        maxRight = max2
        minRight = 0
      } else {
        const [a1, b1, interval1] = compare(max1, min1)
        const [a2, b2, interval2] = compare(max2, min2)
        const a = a1 > a2 ? a1 : a2
        const b = b1 > b2 ? b1 : b2
        inte1 = interval1
        inte2 = interval2
        maxLeft = a * interval1
        minLeft = -b * interval1
        maxRight = a * interval2
        minRight = -b * interval2
      }
      const series1: any = []
      const series2: any = []
      const series3: any = []
      const series4: any = []
      data.forEach((item: any) => {
        if (item.Tag === 0) {
          series1.push(item.PNetProfit)
          series2.push(null)
          series3.push(item.EPS)
          series4.push(null)
        }
        if (item.Tag === 1) {
          series1.push(null)
          series2.push(item.PNetProfit)
          series3.push(null)
          series4.push(item.EPS)
        }
      })
      pageData.option = {
        color: ['#0060FF', '#FF9300', '#0060FF', '#FF9300'],
        tooltip: {
          trigger: 'axis',
          formatter: function(params: any) {
            var htmlStr = ''
            htmlStr += '<div class="optiontooltip"><p style="color:rgba(0,0,0,0.45);">' + params[0].name + '</p>'
            for (var i = 0; i < params.length; i++) {
              // 前面的原点和他的颜色
              let style = 'height: 8px;'
              let value: any = params[i].value
              if (params[i].seriesName === '每股收益（元）' || params[i].seriesName === '预测每股收益（元）') {
                style = 'height: 2px;'
                value = value ? value.toFixed(2) : null
              } else {
                value = value ? globalsets.getNumber(params[i].value) : null
              }
              if (value) {
                htmlStr +=
                  '<span style="width: 8px;' +
                  style +
                  'vertical-align: middle;display:inline-block;margn-right: 4px;background-color:' +
                  params[i].color +
                  '"></span><span style="color:#000;margin-left: 6px;">' +
                  params[i].seriesName +
                  ':</span>' +
                  '<span style="color:#000;float:right;margin-left: 12px">' +
                  value +
                  '</span><br/>'
              }
            }
            htmlStr += '</div>'
            return htmlStr
          }
        },
        grid: [
          {
            top: 30,
            left: 10,
            right: 20,
            bottom: 50,
            containLabel: true
          }
        ],
        toolbox: {
          feature: {}
        },
        legend: [
          {
            bottom: 20,
            itemWidth: 8,
            left: '270',
            itemHeight: 8,
            data: [
              {
                name: '净利润（元）', // 图例文字内容
                icon: 'rect',
                textStyle: {
                  color: '#7D7D7D'
                }
              }
            ]
          },
          {
            bottom: 20,
            itemWidth: 8,
            left: '365',
            itemHeight: 8,
            data: [
              {
                name: '预测净利润（元）', // 图例文字内容
                icon: 'rect',
                textStyle: {
                  color: '#7D7D7D'
                }
              }
            ]
          },
          {
            bottom: 20,
            itemWidth: 8,
            left: '485',
            itemHeight: 2,
            data: [
              {
                name: '每股收益（元）', // 图例文字内容
                icon: 'rect',
                textStyle: {
                  color: '#7D7D7D'
                }
              }
            ]
          },
          {
            bottom: 20,
            itemWidth: 8,
            left: '590',
            itemHeight: 2,
            data: [
              {
                name: '预测每股收益（元）', // 图例文字内容
                icon: 'rect',
                textStyle: {
                  color: '#7D7D7D'
                }
              }
            ]
          }
        ],
        xAxis: [
          {
            type: 'category',
            data: xAxis,
            axisLabel: { interval: 0 },
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            name: '净利润（元）',
            type: 'value',
            interval: inte1,
            max: maxLeft,
            min: minLeft
            // interval: Math.ceil(Math.ceil(max1) / 5),
            // max: Math.ceil(Math.ceil(max1) / 5) * 5
          },
          {
            name: '每股收益（元）',
            type: 'value',
            // max: Math.ceil(max2),
            // interval: Math.ceil(Math.ceil(max2) / 5),
            // max :Math.ceil(Math.ceil(max2) / 5) * 5,
            interval: inte2,
            max: maxRight,
            min: minRight,
            axisLabel: {
              formatter: function(value: any) {
                return (value || 0).toFixed(2)
              }
            }
          }
        ],
        series: [
          {
            name: '净利润（元）',
            type: 'bar',
            yAxisIndex: 0,
            barWidth: 20,
            data: series1,
            stack: 'one'
          },
          {
            name: '预测净利润（元）',
            type: 'bar',
            barWidth: 20,
            yAxisIndex: 0,
            stack: 'one',
            data: series2
          },
          {
            name: '每股收益（元）',
            type: 'line',
            yAxisIndex: 1,
            showSymbol: false,
            data: series3,
            lineStyle: {
              width: 1
            }
          },
          {
            name: '预测每股收益（元）',
            type: 'line',
            yAxisIndex: 1,
            showSymbol: false,
            data: series4,
            lineStyle: {
              width: 1
            }
          }
        ]
      }
    }
    watch(
      () => (props.pageSourceData || {}).ForecastData,
      (val: any) => {
        const data = JSON.parse(JSON.stringify(val))
        if ((data.ForecastList || []).length) {
          data.ForecastList.forEach((item: any, i: number) => {
            item.index = 'ForecastList' + i
          })
        }
        pageData.data = data.ForecastList || []
        pageData.data1 = data.HisForecase
        pageData.info = data.SixMonFor
        nextTick(() => {
          setoption()
          pageData.spinning = false
        })
      }
    )
    return {
      ...toRefs(pageData),
      moment: window.moment,
      getNumber: globalsets.getNumber
    }
  }
})
